<template>
    <div class="embed-responsive embed-responsive-16by9">
        <!--<iframe v-if="false" ref="videoFrame" id="videoFrame2" class="embed-responsive-item"
                :src="url" :src__="`${url}?color=ffffff&title=0&byline=0&portrait=0`"
                frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen data-ready="true"></iframe>-->

        <iframe v-if="isYoutube"    ref="videoFrame" id="videoFrame" type="text/html" width="640" height="360" class="embed-responsive-item"
                :src="`${youtubeEmbedUrl}?autoplay=0`"
                frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

        <iframe v-else-if="isVimeo" ref="videoFrame" id="vimeoVideoFrame" width="640" height="360" class="embed-responsive-item"
                :src="vimeoEmbedUrl"
                frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> <!-- title="{video_title}" -->

        <!-- <iframe ref="videoFrame" type="text/html" width="640" height="360" src="http://www.youtube.com/embed/Xp9iPpzwR6o?autoplay=0" frameborder="0" class="embed-responsive-item"></iframe> -->
    </div>
</template>

<script>
    export default {
        name: 'video-frame',
        props: {
            url: { type: [String], default: null, required: false },
            //some_id: { type: [String, Number], default: null, required: false },
        },
        computed: {
            isYoutube() {
                return /youtube.com/.test(this.url);
            },
            youtubeVideoId() {
                let m = this.url.match(/watch\?v=([^&]+)/);
                return (m && m.length > 1) ? m[1] : null;
            },
            youtubeEmbedUrl() {
                return this.isYoutube ? `http://www.youtube.com/embed/${this.youtubeVideoId}` : '';
            },
            isVimeo() {
                return /vimeo.com/.test(this.url);
            },
            vimeoVideoId() {
                // @note Example: https://vimeo.com/306153355/3e6689e01b | https://vimeo.com/286873141
                //return '306153355';
                let m = this.url.match(/vimeo.com\/([^\\/]+)/); // \/?([^\\/]+)
                return (m && m.length > 1) ? m[1] : null;
            },
            vimeoEmbedUrl() {
                return this.isVimeo ? `https://player.vimeo.com/video/${this.vimeoVideoId}` : '';
            },
        }
    }
</script>

<style scoped>
    .embed-responsive { border: 12px solid #fff; }
</style>